// extracted by mini-css-extract-plugin
export default {"loginbutton":"GoogleLogin_loginbutton__2WaF8","animate-rotate":"GoogleLogin_animate-rotate__CHP6a"};